import { Stack } from '@mui/material';

/**
 * Barre de filtres compacte pour pages liste admin.
 */
export default function ListFiltersBar({ children, sx = {}, ...rest }) {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      flexWrap="wrap"
      useFlexGap
      alignItems="center"
      sx={{ mb: 1.75, ...sx }}
      {...rest}
    >
      {children}
    </Stack>
  );
}
